import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";
import { useLocation, useParams } from "react-router-dom";
import { PDFDownloadLink } from '@react-pdf/renderer';
import QuizReviewPDF from './QuizReviewPDF'; // Adjust the path accordingly


const QuizTestReview = () => {
  const location = useLocation();
  const userDetails = location?.state?.userDetails || {};
  const { summary_id } = useParams();
  const [finalSummarySet, setFinalSummarySet] = useState([]);
  const [finalSummary, setFinalSummary] = useState([]);
  const [questionLocation, setQuestionLocation] = useState(0);
  const [state, setState] = useState([]);
  const [noOfQuestions, setNoOfQuestions] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      let data = { id: summary_id, status: 0 };
      const token = localStorage.getItem("access_token");

      // Define custom headers
      const headers = {
        access_token: token, // Pass the token in the Authorization header
      };
      const result = await Apiservice.GetQuizSummaryById(data, headers);
      if (result.success === true) {
        let retrievedData = result.data;
        setFinalSummarySet(retrievedData);
        setFinalSummary(retrievedData.summary);
        setNoOfQuestions(retrievedData.noOfQuestions)
        setState(JSON.parse(retrievedData.state));
        setLoading(false)
        console.log("final Summary", retrievedData)
      } else {
        console.error(result.message);
      }
    };
    fetchData();
  }, [summary_id]);

  // Function to scroll to the selected question
  const handleQuestionClick = (index) => {
    setQuestionLocation(index);
    document.getElementById(`question-${index}`).scrollIntoView({
      behavior: "smooth",
    });
  };
  return (
    <div className="container-fluid m-0 p-0" style={{ userSelect: 'none' }}>
      <div className="row">
        {
          loading ? (
            <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
              <div className="text-center">
                {/* Spinner with proper rotation */}
                <div
                  className="spinner-border text-primary"
                  role="status"
                  style={{
                    width: "2rem",
                    height: "2rem",
                    borderWidth: "3px",
                  }}
                >
                  <span className="visually-hidden">Loading...</span>
                </div>
                {/* Minimalist Text */}
                <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
              </div>
            </div>
          )
            :
            (
              <>
                <div className="col-md-8 order-md-1 order-2">
                  <div className="row" style={{ position: "sticky", top: "0px", zIndex: 10 }}>
                    <div className="col text-center" style={{ backgroundColor: 'snow' }}>
                      <h5 className="h5">Quiz Review</h5>
                    </div>
                  </div>

                  {/* Question Number Box */}
                  <div className="row mb-2 border border-2-black border-rounded radius-2 p-md-2 m-md-2 p-0 m-0" style={{ backgroundColor: "snow", position: "sticky", top: "40px", zIndex: 10 }}>
                    <div className="col">
                      <div className="d-flex flex-wrap gap-2">
                        {finalSummary.map((q, index) => (
                          <div
                            key={index}
                            className="position-relative border border-black"
                            style={{
                              width: "50px",
                              height: "70px",
                              borderRadius: "10px",
                              backgroundColor: q.isCorrect === 1 ? "green" : "red",
                              overflow: "hidden",
                              cursor: "pointer",
                              position: 'fixed'
                            }}
                            onClick={() => handleQuestionClick(index)}
                          >
                            <div
                              className="w-100 h-50"
                              style={{
                                backgroundColor: index === questionLocation ? "lightgreen" : "aliceblue",
                                borderBottom: "1px solid black",
                              }}
                            ></div>
                            <div className="position-absolute w-100 text-center" style={{ bottom: "5px", fontSize: "12px" }}>
                              {index + 1}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>

                  {/* Question and Options Display */}
                  {finalSummary.length > 0 &&
                    finalSummary.map((m, index) => {
                      return (
                        <div
                          id={`question-${index}`}
                          key={index}
                          className="row mb-2 border border-2-black p-md-2 m-md-2 p-0 m-0"
                          style={{ backgroundColor: "snow" }}
                        >
                          <div className="col">
                            <div className="row mb-2 border">
                              <div className="row">
                                <div className="col">Question : {index + 1}</div>
                                {/* <div className="col"></div> */}
                              </div>
                              <div className="row">
                                <div className="col-md">
                                  <div className="row">
                                    <div className="col">
                                      <h6>Status - {m.isCorrect === 1 ? "Answered Correctly" : "Answered Incorrectly"}</h6>
                                    </div>
                                  </div>
                                </div>
                                <div className="col">
                                  <div className="row">
                                    <div className="col">{m.isCorrect === 1 ? "Mark 1 out of 1" : "Mark 0 out of 1"}</div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            {/* Question Text */}
                            <div className="row mb-2">
                              <div className="col">
                                <div className="row">
                                  <div className="col">
                                    <p>{m.question.question}</p>
                                  </div>
                                </div>

                                {/* Options */}
                                {m.question.options.slice(0, m.question.options.length - 1).map((option, optionIndex) => {
                                  const isSelected = m.selected_option === `${optionIndex + 1}`;
                                  const isCorrect = option.isCorrect;

                                  return (
                                    <div key={optionIndex} className="row mb-2 align-items-center">
                                      <div className="col">
                                        <div className="row mb-1">
                                          <div className="col-2">
                                            <input
                                              type="radio"
                                              className="btn-check"
                                              name={`question-${index}`}
                                              id={`option-${index}-${optionIndex}`}
                                              value={optionIndex + 1}
                                              checked={isSelected}
                                              readOnly
                                            />
                                            <label
                                              className={`btn btn-outline-${isCorrect ? "success" : "danger"}`}
                                              htmlFor={`option-${index}-${optionIndex}`}
                                            >
                                              {String.fromCharCode(97 + optionIndex)} {/* Converts 0 -> 'a', 1 -> 'b', etc. */}
                                            </label>
                                          </div>
                                          <div className="md-col col">{option[`option${optionIndex + 1}`]}</div>
                                          <div className="col-1 text-center">
                                            {isSelected && isCorrect && <span className="text-success fw-bold">✔️</span>}
                                            {isSelected && !isCorrect && <span className="text-danger fw-bold">❌</span>}
                                            {!isSelected && isCorrect && <span className="text-success fw-bold">✔️</span>}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );

                                })}

                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                </div>
                {/* Right Section: Summary Table */}
                <div className="col-md-4 order-md-2 order-1">
                  <div className="row">
                    <div className="col">
                      {
                        !loading && (
                          <div className="text-center my-3">
                            <PDFDownloadLink
                              document={
                                <QuizReviewPDF
                                  summaryData={finalSummary}
                                  summarySet={finalSummarySet}
                                  state={state} userDetails={userDetails}
                                //  userDetails = {}
                                />
                              }
                              fileName={`Quiz_Review_${summary_id}.pdf`}
                              className="btn btn-success"
                            >
                              {({ loading }) =>
                                loading ? 'Generating PDF...' : 'Download Quiz Review PDF'}
                            </PDFDownloadLink>
                            {/* <PDFDownloadLink
                              document={
                                <Document>
                                  <Page size="A4" style={{ padding: 40, paddingBottom: 60 }}>
                                    <Text>Some content...</Text>
                                    <View
                                      fixed
                                      style={{
                                        position: 'absolute',
                                        bottom: 20,
                                        left: 0,
                                        right: 0,
                                        textAlign: 'center',
                                        fontSize: 10,
                                        color: 'grey',
                                      }}
                                    >
                                      <Text
                                        render={({ pageNumber, totalPages }) =>
                                          `Page ${pageNumber} of ${totalPages}`
                                        }
                                      />
                                    </View>
                                  </Page>
                                </Document>
                              }
                              fileName="test.pdf"
                            >
                              {({ loading }) => (loading ? 'Generating...' : 'Download')}
                            </PDFDownloadLink> */}
                          </div>
                        )
                      }
                    </div>
                  </div>

                  <div className="card shadow-sm">
                    <div className="card-header bg-primary text-white text-center fw-bold">Quiz Review Status Card</div>
                    <div className="card-body">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <td><strong>Started On</strong></td>
                            <td>
                              {state.startTime && new Date(state.startTime).toLocaleString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: true
                              })}
                            </td>
                          </tr>

                          <tr>
                            <td><strong>Completed On</strong></td>
                            <td>
                              {state.endTime && new Date(state.endTime).toLocaleString('en-GB', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                                hour: '2-digit',
                                minute: '2-digit',
                                second: '2-digit',
                                hour12: true
                              })}
                            </td>
                          </tr>

                          <tr>
                            <td><strong>Time Taken</strong></td>
                            <td>{state.timeTaken}</td>
                          </tr>
                          <tr>
                            <td><strong>State</strong></td>
                            <td className={finalSummarySet.grade >= 70 ? "text-success" : "text-danger"}>
                              {finalSummarySet.grade >= 70 ? "Passed" : "Failed"}
                            </td>
                          </tr>
                          <tr>
                            <td><strong>Total Marks</strong></td>
                            <td>{finalSummarySet.mark}/{noOfQuestions}</td>
                          </tr>
                          {/* <tr>
                            <td><strong>Grade</strong></td>
                            <td>{(finalSummarySet.grade).toFixed(2)}/10.00</td>
                          </tr> */}
                          <tr>
                            <td><strong>Grade</strong></td>
                            <td>{(finalSummarySet.percentage).toFixed(2)}%</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </>
            )
        }
      </div>
    </div>
  );
};

export default QuizTestReview;
